module.exports = __webpack_public_path__ + "img/messages-dollar.6cb2657d.svg";